import { useEffect } from "react";
import axios from "axios";
import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/tilt/Navbar";
import Hero from "@/components/tilt/Hero";
import EditorialMarquee from "@/components/tilt/EditorialMarquee";
import WhoWeAre from "@/components/tilt/WhoWeAre";
import IrishIdentity from "@/components/tilt/IrishIdentity";
import Contact from "@/components/tilt/Contact";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing() {
  useLenis();

  useEffect(() => {
    axios
      .post(`${API}/track/visit`, { path: "/", referrer: document.referrer || null })
      .catch(() => {});
  }, []);

  return (
    <div className="grain bg-base-bg" data-testid="tilt-landing">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <WhoWeAre />
        <IrishIdentity />
      </main>
      <Contact />
    </div>
  );
}
